import CareerPlanningAnimation from './CareerPlanningAnimation'
export default CareerPlanningAnimation
